import { render, staticRenderFns } from "./homeDashboardCenterMonthlyStatistics.vue?vue&type=template&id=3b871076&scoped=true"
import script from "./homeDashboardCenterMonthlyStatistics.vue?vue&type=script&lang=js"
export * from "./homeDashboardCenterMonthlyStatistics.vue?vue&type=script&lang=js"
import style0 from "./homeDashboardCenterMonthlyStatistics.vue?vue&type=style&index=0&id=3b871076&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b871076",
  null
  
)

export default component.exports